import { render, staticRenderFns } from "./ProvinceRiskTag.vue?vue&type=template&id=03f26592&scoped=true"
import script from "./ProvinceRiskTag.vue?vue&type=script&lang=js"
export * from "./ProvinceRiskTag.vue?vue&type=script&lang=js"
import style0 from "./ProvinceRiskTag.vue?vue&type=style&index=0&id=03f26592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f26592",
  null
  
)

export default component.exports